module.exports = __webpack_public_path__ + "static/media/6-1.44584396.mp3";